import {h} from 'preact';

export function SubTabsContainer({children}) {
	return <div class="h-12 shrink-0 bg-blue-whale-800 w-full text-slate-100 overflow-x-auto">
		<div class="h-full">
			<div class="h-full flex">{children}</div>
		</div>
	</div>
}

export function Tab({children, onClick = null, selected}) {
	if (selected)
		return <div class="cursor-pointer shrink-0 text-center leading-10 w-28 text-xs font-sans text-kobaaccent-400 h-full flex items-center justify-center">
			{children}
		</div>
	return <div class="cursor-pointer shrink-0 text-center leading-10 w-28 text-xs font-sans hover:text-kobaaccent-400 h-full flex items-center justify-center" onClick={onClick}>
		{children}
	</div>
}